import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    siteName: '党领导下的科学家主题展资料库',
    nickName: '',
    deptName: '',
    centiare: 1000,
    isLogin: false,
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
